module.exports = __webpack_public_path__ + "img/guadalajara-logo-for-email.ab9cf709.png";